import type { BranchKey } from '@festina-life/api'
import type { Optional } from '@festina-life/core'
import { useMemo } from 'react'

import { getWorkspacesForBranch } from '../workspace/helpers'
import { useWorkspaceManagerContext } from '../workspace/workspaceManagerContext'

export const useBaseBranchWorkspaces = (branchKey: Optional<BranchKey>) => {
  const { conciseWorkspaces } = useWorkspaceManagerContext()

  return useMemo(
    () => getWorkspacesForBranch(conciseWorkspaces, branchKey),
    [branchKey, conciseWorkspaces],
  )
}
